import React from 'react';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { PRIVATE_LISTER } from './utils/const';
import * as styles from './carousel-agent-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PrivateListerCard = _ref => {
  var agent = _ref.agent,
    largePhoto = _ref.largePhoto;
  return ___EmotionJSX("div", {
    key: agent.name,
    css: styles.agent
  }, ___EmotionJSX(Avatar, {
    css: styles.avatar({
      largePhoto
    }),
    size: "custom"
  }), ___EmotionJSX("p", {
    css: styles.name
  }, agent.name), ___EmotionJSX("p", {
    css: styles.agency
  }, PRIVATE_LISTER));
};
export default PrivateListerCard;